import type { AuthUser } from "@spiriidk/auth";
import _refiner from "refiner-js";

const REFINER_PROJECT_ID = import.meta.env.VITE_REFINER_PROJECT_ID as
  string | undefined;
const IS_LOCAL = import.meta.env.VITE_LOCAL === "true";

function initializeRefiner(authData: AuthUser): void {
  if (!REFINER_PROJECT_ID || IS_LOCAL) {
    return;
  }

  void _refiner("setProject", REFINER_PROJECT_ID);
  void _refiner("identifyUser", {
    id: authData.userId,
    login: authData.login,
    email: authData.email,
    name: authData.name,
    role: authData.userPermissions[0],
    operatorId: authData.permittedOperatorId,
    companyId: authData.permittedCompanyId,
  });
}

export { initializeRefiner };
